import { decamelizeKeys } from 'humps';
import { isEmbeddable } from '../constants/partners';
import { logDebug } from './remoteLogger';

export const MEDIA_PERMISSION_DENIED_EVENT = 'media_permission_denied_event';

export interface IWindowEvent {
  type: string;
  payload?: Record<string, unknown>;
}

/**
 * Tells the page or app hosting an embeddable partner what happened, in the same
 * `{ type, payload }` shape as the window events built by kry-view-layer.
 */
export const postWindowEvent = (
  type: string,
  payload: Record<string, unknown> = {}
) => {
  if (!isEmbeddable()) return;

  logDebug('postWindowEvent', `Will post ${type} to the host`);
  window.parent.postMessage({ type, payload }, '*');
};

/**
 * Flex responses have their keys camelized when parsed, so the payload is turned back
 * into the snake_case keys the backend sent and the host expects. Payload keys must
 * therefore be snake_case: any other key reaches the host converted to snake_case.
 */
export const postFlexWindowEvent = ({ type, payload = {} }: IWindowEvent) =>
  postWindowEvent(type, decamelizeKeys(payload) as Record<string, unknown>);
